import '../styles/pages/Home.scss';
import banner from '../assets/banner.svg';
import bannerBG1 from '../assets/banner-bg1.svg';
import bannerBG2 from '../assets/banner-bg2.svg';
import tunisiaIcon from '../assets/tunisia.png';
import whyIcon1 from '../assets/icons/why-us-1.svg';
import whyIcon2 from '../assets/icons/why-us-2.svg';
import whyIcon3 from '../assets/icons/why-us-3.svg';
import service1 from '../assets/icons/service1.svg';
import service2 from '../assets/icons/service2.svg';
import service3 from '../assets/icons/service3.svg';
import service4 from '../assets/icons/service4.svg';
import { IoChevronBackOutline, IoChevronForwardOutline } from "react-icons/io5";
import { IoStar } from "react-icons/io5";
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRightLong } from "react-icons/fa6";
import QuestionAnswer from '../components/QuestionAnswer';
import { useTranslation, Trans } from 'react-i18next';
import { MdDone } from "react-icons/md";


const Home = () => {
  const { t } = useTranslation();
  const [displayAnswer, setDisplayAnswer] = useState(null);
  const servicesDisplayCount = window.innerWidth > 768 ? 4 : 1
  const [currentIndex, setCurrentIndex] = useState(0);
  const titleText  = t('home.hero.title');
  const parseTitle = (text) => {
    const parts = text.split('<tunisia/>');
    
    return (
      <>
        {parts[0]}<img src={tunisiaIcon} alt='Tunisia' className='tunisia-icon' />
        
      </>
    );
  };
  const services = [
    {
      img: service1,
      title: t('home.services.suarl.title'),
      subtitle: t('home.services.suarl.subtitle'),
      description: t('home.services.suarl.description'),
    },
    {
      img: service2,
      title: t('home.services.sarl.title'),
      subtitle: t('home.services.sarl.subtitle'),
      description: t('home.services.sarl.description'),
    },
    {
      img: service3,
      title: t('home.services.sa.title'),
      subtitle: t('home.services.sa.subtitle'),
      description: t('home.services.sa.description'),
    },
    {
      img: service4,
      title: t('home.services.offshore.title'),
      subtitle: t('home.services.offshore.subtitle'),
      description: t('home.services.offshore.description'),
    },
  ];
  return (
    <div className='main-container'>
      <div className='home-header'>
        <img src={bannerBG2} alt='background' className='background-image' />
        <div className='home-content'>
          <div className='content'>
            <h1>
              {titleText}
              <img src={tunisiaIcon} alt='Tunisia' className='tunisia-icon' />
            </h1>
            <ul className='features-list'>
              <li><MdDone size={20} color='#3CD982' /> {t('home.hero.features.support')}</li>
              <li><MdDone size={20} color='#3CD982' /> {t('home.hero.features.simplified')}</li>
              <li><MdDone size={20} color='#3CD982' /> {t('home.hero.features.success')}</li>
            </ul>
            <span className='price'> {t('home.hero.price')} </span>
            <div className='actions'>
              <a href="https://wa.me/21620372623" target="_blank" rel="noopener noreferrer">
                <button className='rdv'> {t('home.hero.rdv')} </button>
              </a>
              <Link to="/contact">
                <button className='devis'> {t('home.hero.devis')} </button>
              </Link>
            </div>
          </div>
          <div className='banner'>
            <img src={banner} alt='banner' className='img-banner' />
            <img src={bannerBG2} alt='background 2' className='background2' />
          </div>
        </div>
      </div>
      <div className='why-us-container'>
        <h2> {t('home.whyUs.title')} </h2>
        <div className='why-us'>
          <div className='reasons'>
            <div className='reason'>
                <img src={whyIcon3} alt='expertise' />
                <span> {t('home.whyUs.expertise')} </span>
            </div>
            <div className='reason'>
                <img src={whyIcon2} alt='international' />
                <span> {t('home.whyUs.international')} </span>
            </div>
            <div className='reason'>
                <img src={whyIcon1} alt='rapide' />
                <span> {t('home.whyUs.fast')} </span>
            </div>
          </div>
        </div>
      </div>
      <div className='services-container'>
        <h2> {t('home.services.title')} </h2>
        <div className='services'>
          <div className='services'>
            <button onClick={() => setCurrentIndex(prev => (prev === 0 ? services.length - servicesDisplayCount : prev - 1))}>
              <IoChevronBackOutline />
            </button>
            {services
              .slice(currentIndex, currentIndex + servicesDisplayCount)
              .map((service, index) => (
                <div className='service-card' key={index}>
                  <img src={service.img} alt={service.title} />
                  <h3>{service.title}</h3>
                  {service.subtitle && <span>{service.subtitle}</span>}
                  <p>{service.description}</p>
                </div>
            ))}
            <button onClick={() => setCurrentIndex(prev => (prev + 1) % (services.length - servicesDisplayCount + 1))}>
              <IoChevronForwardOutline />
            </button>
          </div>
        </div>
      </div>
      <div className='steps'>
          <h2> {t('home.steps.title')} <span className='colored'>{t('home.steps.colored')}</span> </h2>
          <div className="steps-container">
              <div className="step-wrapper">
                  <div className="step first-step"></div>
                  <div className='content first-step'>
                      <span>{t('home.steps.step1.number')}</span>
                      <h3>{t('home.steps.step1.title')}</h3>
                      <p>{t('home.steps.step1.description')}</p>
                  </div>
              </div>
              <div className="step-wrapper">
                  <div className="step"></div>
                  <div className='content'>
                      <span>{t('home.steps.step2.number')}</span>
                      <h3>{t('home.steps.step2.title')}</h3>
                      <p>{t('home.steps.step2.description')}</p>
                  </div>
              </div>
              <div className="step-wrapper">
                  <div className="step"></div>
                  <div className='content'>
                      <span>{t('home.steps.step3.number')}</span>
                      <h3>{t('home.steps.step3.title')}</h3>
                      <p>{t('home.steps.step3.description')}</p>
                  </div>
              </div>
              <div className="step-wrapper">
                  <div className="step last-step"></div>
                  <div className='content last-step'>
                      <span>{t('home.steps.step4.number')}</span>
                      <h3>{t('home.steps.step4.title')}</h3>
                      <p>{t('home.steps.step4.description')}</p>
                  </div>
              </div>
          </div>
      </div>
      <div className='faq-section'>
        <h2> {t('home.faq.title')} <span className='colored'>{t('home.faq.colored')}</span> {t('home.faq.end')} </h2>
        <div className="questions">
          <QuestionAnswer 
            index={1}
            question={t('home.faq.q1.question')} 
            answers={[t('home.faq.q1.answer1'), t('home.faq.q1.answer2')]}
            displayAnswer={displayAnswer === 1}
            setDisplayAnswer={setDisplayAnswer}
          />
          <QuestionAnswer 
            index={2}
            question={t('home.faq.q2.question')} 
            answers={[t('home.faq.q2.answer1'), t('home.faq.q2.answer2')]}
            displayAnswer={displayAnswer === 2}
            setDisplayAnswer={setDisplayAnswer}
          />
          <QuestionAnswer 
            index={3}
            question={t('home.faq.q3.question')} 
            answers={[t('home.faq.q3.answer1'), t('home.faq.q3.answer2')]}
            displayAnswer={displayAnswer === 3}
            setDisplayAnswer={setDisplayAnswer}
          />
        </div>
        <Link to="/faq">
          <button>{t('home.faq.button')} <FaArrowRightLong /></button>
        </Link>
      </div>
      <div className='testimonial-container'>
        <h2> {t('home.testimonials.title')} </h2>
        <div className='testimonials-main'>
          <button>
              <IoChevronBackOutline />
          </button>
          <div className='testimonials'>
              <div className='testimonial-card'>
                <div className='stars'> <IoStar /><IoStar /><IoStar /><IoStar /><IoStar /> </div>
                <p> {t('home.testimonials.t1.text')} </p>
                <span> {t('home.testimonials.t1.author')} </span>
              </div>
              <div className='testimonial-card'>
                  <div className='stars'> <IoStar /><IoStar /><IoStar /><IoStar /><IoStar /> </div>
                  <p> {t('home.testimonials.t2.text')} </p>
                  <span> {t('home.testimonials.t2.author')} </span>
              </div>
              <div className='testimonial-card'>
                  <div className='stars'> <IoStar /><IoStar /><IoStar /><IoStar /><IoStar /> </div>
                  <p> {t('home.testimonials.t3.text')} </p>
                  <span> {t('home.testimonials.t3.author')} </span>
              </div>
          </div>
          <button>
              <IoChevronForwardOutline />
          </button>
        </div>
      </div>  
    </div>
  );
}

export default Home;
